import { render, staticRenderFns } from "./PortalGuidelines.vue?vue&type=template&id=356f2aa5"
import script from "./PortalGuidelines.vue?vue&type=script&lang=js"
export * from "./PortalGuidelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports